/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'feedback-collector.anonymous': 'Deze feedback wordt anoniem verzonden. Atlassian kan niet rechtstreeks contact met je opnemen over de feedback.',
  'feedback-collector.anonymous.title': 'Anonieme feedback',
  'feedback-collector.can-be-contacted.label': 'Ja, Atlassian-teams mogen contact met me opnemen om te vragen naar mijn ervaringen, zodat Atlassian-producten en -diensten kunnen worden verbeterd. Ik stem in met het <a>Privacybeleid van Atlassian</a>.',
  'feedback-collector.cancel-button.label': 'Annuleren',
  'feedback-collector.default.custom.textarea.label': 'Waar denk je aan?',
  'feedback-collector.enrol-in-research.label': 'Ik wil graag meewerken aan productonderzoek',
  'feedback-collector.feedback-title': 'Laat ons weten wat je ervan vindt',
  'feedback-collector.form.bug.label': 'De bug of issue beschrijven',
  'feedback-collector.form.comment.label': 'Laat ons weten wat je vindt',
  'feedback-collector.form.empty.label': 'Kies een optie',
  'feedback-collector.form.question.label': 'Wat zou je willen weten?',
  'feedback-collector.form.suggestion.label': 'Laat ons weten wat je zou willen verbeteren',
  'feedback-collector.option.bug.label': 'Rapporteer een bug',
  'feedback-collector.option.comment.label': 'Laat een reactie achter',
  'feedback-collector.option.default.label': 'Feedback selecteren',
  'feedback-collector.option.default.placeholder': 'Kies er een',
  'feedback-collector.option.question.label': 'Een vraag stellen',
  'feedback-collector.option.suggestion.label': 'Een verbetering voorstellen',
  'feedback-collector.required.fields.summary': 'Verplichte velden zijn aangeduid met een asterisk',
  'feedback-collector.submit-button.label': 'Feedback sturen',
  'feedback-collector.success-flag.description': 'Met jouw feedback kunnen we onze producten steeds verder verbeteren.',
  'feedback-collector.success-flag.title': 'Bedankt!',
  'feedback-collector.summary-placeholder': 'Laat ons weten wat je vindt',
  'proforma-form-builder.feedback-icon-label': 'Feedback',
  'proforma-form-builder.give-feedback': 'Feedback geven'
};